<template>
    <section class="faq">
        <div class="row">
            <div class="col-sm-12 d-flex faq-title">
                <h6>سوالات متداول</h6>
            </div>
            <div class="col-sm-12 d-flex faq-collapse bg-white">
                <div class="d-flex faq-collapse-titr">
                    <div class=" faq-collapse-titr-p">
                        <span>3</span>
                        <p>امکان مشاهده گزارش خرید وفروش های خود</p>
                    </div>

                    <div  class=" faq-collapse-titr-collaps">
                        <i v-b-toggle="'collapse-1'" class="icon-angle-down"></i>
                    </div>
    
                </div>

                <b-collapse id="collapse-1" class="faq-collapse-titr-collaps-desc">
                     <p>خلاصه فرایند اجرایی سامانه معلم یار شامل مراحل زیر می باشد:</p>
                     <p>• تولید کنندگان و تامین کنندگان کالاهای قابل عرضه خود را روی ویترین اختصاصی خود با تمام مشخصات مربوطه قرار می دهند.</p>
                     <p>• معلمان کالاهای مورد نیاز خود را از ویترین تامین کنندگان و تولید کنندگان انتخاب کرده و در یک سبد قرار می دهند .</p>
                     <p>• حامیان با مشاهده سبدهای درخواستی از معلمان برای تأمین هزینه سبدها اقدام می کنند</p>
                     <p>• تیم معلم یار بعد از تأمین مالی هر سبد از طرف حامیان اقلام آن را از تأمین کنندگان خریداری می‌کنند و به معلم درخواست کننده تحویل می دهند</p>
                     <p>• رسید به همراه خلاصه مراحل انجام شده در اختیار حامیان قرار می گیرد.</p>
                     <p>• کلیه عملیات بصورت شفاف با ذکر کلیه اطلاعات روی سامانه منتشر و قابل مشاهده همگان می باشد.</p>
                     <p>• کلیه عملیات بصورت شفاف با ذکر کلیه اطلاعات روی سامانه منتشر و قابل مشاهده همگان می باشد.</p>
                     <p>• تمامی عملیات هم بصورت شفاف و آنلاین نمایش داده میشود .</p>
                </b-collapse>
            </div>

            <div class="col-sm-12 d-flex faq-collapse bg-white">
                <div class="d-flex faq-collapse-titr">
                    <div class=" faq-collapse-titr-p">
                        <span>3</span>
                        <p>هزینه استفاده از خدمات سامانه معلم یار چقدراست؟</p>
                    </div>
                    <div  class=" faq-collapse-titr-collaps">
                        <i v-b-toggle="'collapse-2'" class="icon-angle-down"></i>
                    </div>
                </div>
                <b-collapse id="collapse-2" class="faq-collapse-titr-collaps-desc">
                     <p>استفاده از خدمات سامانه باهم برای مراکزتقاضا، تامین کنندگان، و خریداران در طول بحران کرونا رایگان می باشد و این هزینه ها در این مدت توسط سهامداران شرکت رخش و شرکت خدمات فناوری تکچی و افراد علاقه مند تامین میگردد.</p>
                </b-collapse>
            </div>

            <div class="col-sm-12 d-flex faq-collapse bg-white">
                <div class="d-flex faq-collapse-titr">
                    <div class=" faq-collapse-titr-p">
                        <span>3</span>
                        <p>ازکجا بدانیم اقلام خریداری شده به معلمان میرسد؟</p>
                    </div>
                    <div  class=" faq-collapse-titr-collaps">
                        <i v-b-toggle="'collapse-3'" class="icon-angle-down"></i>
                    </div>
                </div>
                <b-collapse id="collapse-3" class="faq-collapse-titr-collaps-desc">
                     <p>کلیه فرایند اجرای کار بطور شفاف درسامانه قابل مشاهده است . برای هر معلما، نوع کالا، تعداد، قیمت، تامین کننده، تحویل گیرنده ، پرداخت کننده ، تاریخ، تحویل گیرنده و تصویر رسید رسمی وفاکتور روی سامانه نشان داده می شود. رسید دریافت اقلام سبد درخواستی توسط معلم مربوطه امضاء شده در سامانه نمایش داده می شود.</p>
                </b-collapse>
            </div>
        </div>
        <div class="faq-pic"></div>
    </section>
</template>

<script>
export default {
    name: "Faq"
}
</script>